<template>
  <div v-if="categories!.length">
    <p class="text-left font-bold text-gray-700 mb-1">
      {{
        $t(
          "components.resources.categories.categoriesCarousel.filterByCategory",
        )
      }}
    </p>

    <ACarousel
      :items="sortedCategories"
      :space-between="10"
      :free-mode="{ enabled: true }"
      :breakpoints="{
        320: {
          slidesPerView: 'auto',
        },
      }"
    >
      <template #default="{ item }">
        <UButton
          :key="item.id"
          :to="localePath(item.to!)"
          active-class="!bg-blue-50 !border-blue-400 !text-blue-500"
          variant="ghost"
          class="flex flex-1 items-center justify-center py-2 px-3 size-28 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 text-gray-800 hover:border-gray-400 transition-colors flex-col"
        >
          <div v-if="item.svg" v-html="item.svg"></div>
          <span class="mt-2">{{ item.label }}</span>
        </UButton>
      </template>
      <template #fallback>
        <div class="flex justify-center items-center gap-x-4">
          <USkeleton v-for="i in 10" :key="i" class="size-28" />
        </div>
      </template>
    </ACarousel>
    <UButton
      v-if="$route.params.category"
      class="mt-4"
      :padded="false"
      color="red"
      variant="link"
      leading-icon="mdi:close"
      @click="$router.push(localePath({ name: 'trips' }))"
    >
      {{ $t("components.resources.categories.categoriesCarousel.reset") }}
    </UButton>
  </div>
</template>

<script lang="ts" setup>
const { data: categories, error: categoriesError } = await useFetch(
  '/api/categories/trips',
)
assertDefined(categories, categoriesError)

const localePath = useLocalePath()
const route = useRoute()

const sortedCategories = computed(() => {
  if (!route.params.category)
    return categories.value!.sort((a, b) => a.id - b.id)

  return categories.value!.sort((a, b) => {
    if (a.to?.params?.category === route.params.category)
      return -1
    if (b.to?.params?.category === route.params.category)
      return 1
    return String(a.to).localeCompare(String(b.to))
  })
})
</script>

<style></style>
